module.exports = __webpack_public_path__ + "static/img/Y2D50.6e5be94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Y2D50.png
// module id = E6X0
// module chunks = 2